import { WithTargetForAllLinks } from '@atlassian/amkt-common';
/* DOMPurify does not support destructured import - https://github.com/cure53/DOMPurify/issues/636#issuecomment-1026211118 */
import DOMPurify from 'dompurify';
import React, { forwardRef } from 'react';
import { Content } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component is practically same as "packages/mpac-ui/src/components/UserGeneratedHtml/UserGeneratedHtml.tsx" but
 * to be used in new Marketpalce experience and the old component can now be deprecated
 */
const UserGeneratedHTML = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    dangerousHTML,
    'data-testid': testId
  } = props;
  return /*#__PURE__*/_jsx(WithTargetForAllLinks, {
    target: "_blank",
    children: /*#__PURE__*/_jsx(Content, {
      "data-testid": testId,
      ref: ref,
      as: "div"
      /* eslint-disable-next-line marketplace-frontend/no-dangerous-html -- This is the common component to be used for all dangerouslySetInnerHTML required cases */,
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(dangerousHTML)
      }
    })
  });
});
UserGeneratedHTML.displayName = 'UserGeneratedHTML';
export { UserGeneratedHTML };